import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Metrics } from '../../../models/metrics';
import { UnansweredQuestion } from '../../../models/unanswered-question';
import { Intervention } from '../../../models/intervention';
import { Module } from 'src/app/models/module';
import { Participant } from 'src/app/models/participant';
import { Filter } from '../../../models/filter';

export const getMetrics = createAction(
  '[Metrics] Get Metrics',
  props<{ studyId: number; interventionId?: number; moduleId?: number }>()
);

export const getMetricsSuccess = createAction('[Metrics] Get Metrics Success', props<{ metrics: Metrics }>());

export const getMetricsError = createAction('[Metrics] Get Metrics Error', props<{ err: HttpErrorResponse }>());

export const getFilters = createAction(
  '[Metrics] Get Filters',
  props<{ studyId: number }>()
);

export const getFiltersSuccess = createAction(
  '[Metrics] Get Filters Success',
  props<{ filter: Filter }>()
);

export const getUnansweredQuestions = createAction(
  '[Metrics] Get Unanswered Questions',
  props<{ studyId: number; interventionId?: number; moduleId?: number }>()
);

export const getUnansweredQuestionsSuccess = createAction(
  '[Metrics] Get Unanswered Questions Success',
  props<{ unanswered: UnansweredQuestion[] }>()
);

export const getUnansweredQuestionsError = createAction(
  '[Metrics] Get Unanswered Questions Error',
  props<{ err: HttpErrorResponse }>()
);

export const resetValues = createAction(
  '[Metrics] Reset Values',
);

export const getParticipantScreeningResponsesSuccess = createAction(
  '[Metrics] Get Participant Screening Responses Success',
  props<{ metrics: Metrics }>()
);

export const getParticipantScreeningResponsesError = createAction(
  '[Metrics] Get Participant Screening Responses Error',
  props<{ err: HttpErrorResponse }>()
);

export const getParticipantScreeningResponses = createAction(
  '[Metrics] Get Participant Screening Responses',
  props<{ studyId: number; participantId: number }>()
);

export const downloadInterventionAnswers = createAction(
  '[Metrics] Download Intervention Answers',
  props<{ languageCode: string; interventionId: number, version: string }>()
);

export const downloadInterventionAnswersSuccess = createAction('[Metrics] Download Intervention Answers Success');

export const downloadInterventionAnswersError = createAction(
  '[Metrics] Download Intervention Answers Error',
  props<{ err: HttpErrorResponse }>()
);

export const downloadInterventionAnswersTiming = createAction(
  '[Metrics] Download Intervention Answers Timing',
  props<{ interventionId: number }>()
);

export const downloadInterventionAnswersTimingSuccess = createAction(
  '[Metrics] Download Intervention Answers Timing Success'
);

export const downloadInterventionAnswersTimingError = createAction(
  '[Metrics] Download Intervention Answers Timing Error',
  props<{ err: HttpErrorResponse }>()
);

export const downloadInterventionFiles = createAction(
  '[Metrics] Download Intervention Files',
  props<{ keyForFiles: string; studyId: number; interventionId: number; moduleId: number }>()
);

export const downloadInterventionFilesSuccess = createAction('[Metrics] Download Intervention Files Success');

export const downloadInterventionFilesError = createAction(
  '[Metrics] Download Intervention Files Error',
  props<{ err: HttpErrorResponse }>()
);

export const downloadInterventionParticipantData = createAction(
  '[Metrics] Download Participant Data',
  props<{ interventionId: number; participantId: number }>()
);

export const downloadInterventionParticipantDataSuccess = createAction('[Metrics] Download Participant Data Success');

export const downloadInterventionParticipantDataError = createAction(
  '[Metrics] Download Participant Data Error',
  props<{ err: HttpErrorResponse }>()
);
